import React from "react";
import '../style/Register.css';


export default function Register() {
    return (
        <>
            <div className="Login">
                <img className="Img" src={require("../img/1000.png")} alt="Error" />
                <div className="box-log mt-4">
                    <p className="lead  ">Kirish</p>
                    <hr />
                    <div className="input-title  d-flex justify-content-between">
                        <p className="input_p text-secondary">Email</p>
                    </div>
                    <input type="text" class="form-control input1" placeholder="Email" />
                    <div className="input-title mt-2 d-flex justify-content-between">
                        <p className="input_p text-secondary">Joriy parolingiz</p>
                    </div>
                    <input type="text" class="form-control input1" placeholder="Joriy parolingiz" />
                    <p className="text-start mt-3 ">Kira olmayapsizmi?</p>
                    <button className="btn-log form-control">Kirish</button>
                </div>
            </div>
        </>
    )
}